import { Component } from 'react'

export default class extends Component {
  render() {
    return this.props.children
  }
}
